import { Button, Form, Text } from "../../../components";
import Localization from "../../../localization";
import React, { useRef } from "react";
import { Flex } from "antd";

const Contact = ({ onCancel = () => {}, onSend = () => {} }) => {
  const formRef = useRef();

  return (
    <div>
      <Text
        weight={400}
        type="secondary"
        children={Localization.unsupported_device.contact_desc}
      />
      <Form
        ref={formRef}
        className="m-20-t"
        fields={[
          {
            name: "name",
            label: Localization.general.your_name,
            placeholder: Localization.placeholder.enter_your_name,
            rules: [
              { required: true, message: Localization.feedback.required_name },
            ],
          },
          {
            name: "phone",
            label: Localization.general.your_phone_number,
            rules: [{ required: true, type: "phone" }],
            placeholder: Localization.placeholder.enter_your_phone_number,
          },
        ]}
      />
      <Flex gap={"1rem"} className="m-30-t">
        <Button
          type="primary"
          title={Localization.general.send}
          onClick={async () => {
            await formRef.current.validateFields();
            await onSend(formRef.current.getFieldsValue());
          }}
        />
        <Button title={Localization.general.cancel} onClick={onCancel} />
      </Flex>
    </div>
  );
};

export default Contact;
